import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { Warning } from '@mui/icons-material';

const ConfirmationModal = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "Confirmer l'action",
  message = "Êtes-vous sûr de vouloir effectuer cette action ?",
  confirmText = "Confirmer",
  cancelText = "Annuler",
  severity = "warning",
  loading = false
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 1 }}>
        {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Warning color={severity} /> */}
          <Typography variant="h6" component="span">
            {title}
          </Typography>
        {/* </Box> */}
      </DialogTitle>
      
      <DialogContent sx={{ pt: 2 }}>
        <Alert severity={severity} sx={{ mb: 2 }}>
          <Typography variant="body1">
            {message}
          </Typography>
        </Alert>
      </DialogContent>
      
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={onClose} 
          disabled={loading}
          variant="outlined"
        >
          {cancelText}
        </Button>
        <Button 
          onClick={onConfirm} 
          disabled={loading}
          variant="contained"
          color={severity === 'error' ? 'error' : 'primary'}
          // startIcon={loading ? null : <Warning />}
        >
          {loading ? 'Traitement...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
